export default "__VITE_ASSET__a412be7d__"